export function getPoints(langName, points, type = 0) {
  let pointName = ''
  if (langName === "RU") {
    pointName = 'балл';
    const lastDigit = points % 10;
    const twoLastDigits = points % 100;
    if (type === 0) {
      if((10 < twoLastDigits && twoLastDigits < 15) || (5 <= lastDigit && lastDigit <= 9) || lastDigit === 0 ){
        pointName += 'ов';
      } else if (2 <= lastDigit && lastDigit <= 4) {
        pointName += 'а';
      }
    } else {
      if (1 === lastDigit && twoLastDigits !== 11) {
        pointName += 'а';
      } else {
        pointName += 'ов';
      }
    }
    //console.log(points + " - " + pointName + " - " + lastDigit)
  } else if (langName === "ES") {
    pointName = 'punto'
    if (points > 1) {
      pointName += 's'
    }
  } else {
    pointName = 'point';
    if (points > 1) {
      pointName += 's'
    }
  }
  return pointName;
}